import { render, staticRenderFns } from "./AdminTemplates.vue?vue&type=template&id=dd2c7cb8&scoped=true&"
import script from "./AdminTemplates.vue?vue&type=script&lang=js&"
export * from "./AdminTemplates.vue?vue&type=script&lang=js&"
import style0 from "./AdminTemplates.vue?vue&type=style&index=0&id=dd2c7cb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2c7cb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd2c7cb8')) {
      api.createRecord('dd2c7cb8', component.options)
    } else {
      api.reload('dd2c7cb8', component.options)
    }
    module.hot.accept("./AdminTemplates.vue?vue&type=template&id=dd2c7cb8&scoped=true&", function () {
      api.rerender('dd2c7cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminTemplates.vue"
export default component.exports